module.exports = __webpack_public_path__ + "static/media/ic_menu.a01f7168.svg";